// extracted by mini-css-extract-plugin
export default {"navigationCartIcon":"NavigationCartIcon_navigationCartIcon__hXHTZ"};